<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateTemplate"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateTemplate"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="name"
        :label="'Name'|pgettext('Templates')"
      >
        <ItpFormInput
          name="name"
          size="md"
          v-model="item.name"
          required
          autofocus
          :placeholder="'Name of template'|pgettext('Templates')"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="name"
        :label="'Object type'|pgettext('Templates')"
      >
        <ItpFormSelect
          name="name"
          size="md"
          v-model="item.object_type"
          :options="objectTypes"
          required
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="template_type"
        :label="'Template type'|pgettext('Templates')"
        :description="'Emails are generated from MJML templates, PDF documents are generated from HTML templates.'|pgettext('Templates')"
      >
        <ItpFormSelect
          name="template_type"
          size="md"
          v-model="item.template_type"
          required
          :options="templateTypes"
        >
        </ItpFormSelect>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="formId"
      :text="'Save'|pgettext('Templates')"
      type="submit"
      variant="primary"
      default
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('Templates')"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateTemplate extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "sm",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateTemplate')
  }

  objectTypes!: any;

  async $$load_objectTypes() {
    return this.$fn.getEnumValuesFromSchema('ObjectTypes')
  }

  templateTypes!: any;

  async $$load_templateTypes() {
    return this.$fn.getEnumValuesFromSchema('TemplateTypes')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['formId', 'formName', 'item', 'objectTypes', 'templateTypes', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        formName: "template",
        item: null,
        objectTypes: null,
        templateTypes: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Templates", "Create Template"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5774_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5774, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_5780_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_5780, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async evh_1040167445267876_success_5779_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_5779, alias=undefined
    return !!this.modalName
  }

  async act_1040167445267876_request_5778_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_5778, alias=submit
    return {
      operation: "create_template",
      data: { ...this.item, content: '<div></div>' },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5774: actions.CloseModalAction;
    evh_7315092382398562_close_5773: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_5776: actions.CloseComponentAction;
    evh_2248226175642056_close_5775: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_5780: actions.CloseModalAction;
    evh_1040167445267876_success_5779: actions.EventHandlerImpl;
    act_1040167445267876_request_5778: actions.RequestAction;
    evh_1040167445267876_submit_5777: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_5782: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_5781: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5774 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5774_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5773 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5774,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5773],
      }
    );
    const act_2248226175642056_closeComponent_5776 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_5775 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_5776,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_5775],
      }
    );
    const act_1040167445267876_closeModal_5780 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_5780_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_5779 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_5780,
        event: "success",
        when: this.evh_1040167445267876_success_5779_getWhen,
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_5778 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_5778_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_5779],
      }
    );
    const evh_1040167445267876_submit_5777 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_5778,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_5777],
      }
    );
    const act_1419464017721962_closeModal_5782 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_5781 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_5782,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_5781],
      }
    );
    return {
      act_7315092382398562_closeModal_5774,
      evh_7315092382398562_close_5773,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_5776,
      evh_2248226175642056_close_5775,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_5780,
      evh_1040167445267876_success_5779,
      act_1040167445267876_request_5778,
      evh_1040167445267876_submit_5777,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_5782,
      evh_1419464017721962_clickPreventStop_5781,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_5778,
    }
  }
}

Vue.component("CreateTemplate", CreateTemplate);

</script>